module.exports = __webpack_public_path__ + "static/img/xwq_02.84b7119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xwq_02.png
// module id = 6HU2
// module chunks = 0